import { useContext } from 'react'
import { PassContext } from '../../pass-context.js'
import dataSelector from '../data-selector'
import PopupEditor from '../popup-editor'

import Card from './components/card'
import Logo from './components/logo'
import Header from './components/header'
import Fields from './components/fields'
import Barcode from './components/barcode'
import HeroImage from './components/hero-image'

const GoogleLoyaltyFront = () => {

  return (
    <Card >
      <Logo />
      <div className="inset loyalty">
        <Header />
        <Fields/>
      </div>
      <Barcode />
      <HeroImage />
    </Card>
  )
}

const PointsBalance = () => {

  const { objectData, variables } = useContext(PassContext)

  const resolvedLoyaltyPoints = dataSelector({ objectData, variables, path: "loyaltyPoints" })

  let balance = 0

  if (resolvedLoyaltyPoints.balance.int) balance = resolvedLoyaltyPoints.balance.int
  if (resolvedLoyaltyPoints.balance.string) balance = resolvedLoyaltyPoints.balance.string
  if (resolvedLoyaltyPoints.balance.double) balance = resolvedLoyaltyPoints.balance.double
  if (resolvedLoyaltyPoints.balance.money) balance = resolvedLoyaltyPoints.balance.money.micros.toLocaleString('en-US', { style: 'currency', currency: resolvedLoyaltyPoints.balance.money.currencyCode, minimumFractionDigits: 0 })

  return (
    <div className="points">
      <PopupEditor title="Loyalty Points" type="loyaltyPoints">
        <div className="editable">
          <div className="label">{resolvedLoyaltyPoints.label}</div>
          <div className="value">{balance}</div>
        </div>
      </PopupEditor>
    </div>
  )
}

export default GoogleLoyaltyFront